import { Strategy } from '@wix/ambassador-bookings-v2-bookings-settings/types';

/**
 * The genders a customer can pick. Every request shape carries its own
 * generated enum, and each adds `UNKNOWN_REQUESTED_GENDER` — a value that must
 * never reach a request, a label map or the URL restorer — so callers hold this
 * narrower type and convert on the way out.
 */
export let RequestedGender = /*#__PURE__*/function (RequestedGender) {
  RequestedGender["ANY_MALE"] = "ANY_MALE";
  RequestedGender["ANY_FEMALE"] = "ANY_FEMALE";
  return RequestedGender;
}({});

/** Offered regardless of the staff genders behind them, so the choice is stable. */
export const SELECTABLE_GENDERS = [RequestedGender.ANY_FEMALE, RequestedGender.ANY_MALE];
export const isRequestedGender = value => !!value && Object.values(RequestedGender).includes(value);

/**
 * Off unless the owner turned it on: the server rejects the whole availability
 * call with `REQUESTED_GENDER_NOT_ALLOWED` on a site whose staff genders aren't
 * publicly accessible. A site that assigns the staff member itself leaves the
 * customer no staff choice for a gender to narrow.
 */
export const isGenderSelectionAllowedBySettings = bookingsSettings => {
  const {
    allowGenderSelection,
    strategy
  } = (bookingsSettings == null ? void 0 : bookingsSettings.staffSelection) ?? {};
  return !!allowGenderSelection && strategy !== Strategy.CUSTOMER_CANNOT_CHOOSE;
};
//# sourceMappingURL=staffGender.js.map